export default {
    GiveAwayAPI_URL: 'https://api-loyalty.wfiws-dev.eu-west-1.aws.pmicloud.biz',
    Tools_Env: 'dev',
    SSO_CallbackUrl: 'https://ems-bo.wfiws-dev.eu-west-1.aws.pmicloud.biz/login',
    CognitoCustomDomain: 'https://wfiws-dev-ems.auth.eu-west-1.amazoncognito.com'
}